import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

interface CategoryHeroProps {
  name: string;
  description: string;
  icon: string;
  slug: string;
  videoCount: number;
}

const heroImages: Record<string, string> = {
  'wanghong-fanche': 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20live%20streaming%20studio%20collapse%20scene%2C%20warm%20coral%20and%20red%20gradient%2C%20geometric%20shapes%20exploding%2C%20cinematic%20atmosphere%2C%20dark%20background%20with%20warm%20accents%2C%20editorial%20quality%2C%20professional%20composition&width=1600&height=600&seq=cat-hero-wanghong&orientation=landscape',
  'mingxing-bagua': 'https://readdy.ai/api/search-image?query=Abstract%20red%20carpet%20event%20with%20paparazzi%20flashes%2C%20warm%20golden%20and%20coral%20tones%2C%20dramatic%20spotlights%2C%20cinematic%20atmosphere%2C%20editorial%20style%2C%20dark%20background%20with%20warm%20light%20streaks%2C%20professional%20composition&width=1600&height=600&seq=cat-hero-mingxing&orientation=landscape',
  'remen-baoliao': 'https://readdy.ai/api/search-image?query=Abstract%20breaking%20news%20concept%20with%20dramatic%20warm%20amber%20and%20coral%20burst%2C%20geometric%20shapes%20radiating%2C%20cinematic%20atmosphere%2C%20editorial%20style%2C%20dark%20background%20with%20intense%20warm%20highlights&width=1600&height=600&seq=cat-hero-remen&orientation=landscape',
  'fancha-shipin': 'https://readdy.ai/api/search-image?query=Abstract%20duality%20split%20composition%20with%20dramatic%20contrast%2C%20warm%20and%20cool%20tone%20division%2C%20geometric%20mirror%20effect%2C%20cinematic%20atmosphere%2C%20editorial%20style%2C%20dark%20background%20with%20warm%20and%20amber%20accents&width=1600&height=600&seq=cat-hero-fancha&orientation=landscape',
};

export default function CategoryHero({ name, description, icon, slug, videoCount }: CategoryHeroProps) {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('opacity-100', 'translate-y-0');
          el.classList.remove('opacity-0', 'translate-y-8');
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative w-full min-h-[420px] md:min-h-[480px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImages[slug] || heroImages['remen-baoliao']}
          alt={`${name} - 吃瓜视频`}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
      </div>

      <div
        ref={contentRef}
        className="relative z-10 w-full px-4 md:px-6 opacity-0 translate-y-8 transition-all duration-700 ease-out"
      >
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start lg:items-end justify-between gap-6">
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/20 border border-primary-500/30 mb-4">
              <i className={`${icon} text-primary-400 text-sm`}></i>
              <span className="text-primary-300 text-xs font-medium">吃瓜视频 · 分类专区</span>
            </div>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-3">
              {name}
              <span className="text-primary-400">专区</span>
            </h1>
            <p className="text-background-200 text-sm md:text-base max-w-lg leading-relaxed">
              {description} · 每日更新最新{name}视频，免费吃瓜视频下载观看，吃瓜吃到饱！
            </p>
          </div>

          <div className="flex-shrink-0 flex items-center gap-3">
            <div className="text-right">
              <p className="text-background-400 text-xs">共收录</p>
              <p className="text-primary-400 font-heading text-3xl font-bold">{videoCount}</p>
              <p className="text-background-400 text-xs">个视频</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}